import { WhatsNewButton } from '@/view/shared/versionCheck';
import { useWhatsNewViewModel } from '@/viewmodel/shared/versionCheck';
import type { ReactNode } from 'react';

export function WhatsNew(): ReactNode {
  const whatsNew = useWhatsNewViewModel();
  return whatsNew ? <WhatsNewButton {...whatsNew} /> : null;
}
